<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card>
            <div v-if="!loaded">
                <img src="assets/ajax-loader.gif" style="padding: 10px;" />
            </div>

            <!-- Summary report for each category -->
            <div id="report-body" v-if="loaded" class="w-100">
                <div v-if="params.summary.length > 0">
                    <div id="report-result">
                        <b-table-simple bordered style="margin-bottom: 0px;">
                            <b-thead head-variant="dark">
                                <tr>
                                    <th width="100%" align="left">
                                        <div>
                                            Summary
                                        </div>
                                    </th>
                                </tr>
                            </b-thead>
                        </b-table-simple>
                        <b-table-simple bordered style="font-size: smaller;">
                            <b-thead head-variant="light">
                                <tr>
                                    <th style="text-align: left;">Category</th>
                                    <th style="text-align: center;">
                                        Purchases
                                    </th>
                                    <th style="text-align: center;">
                                        Total Sold
                                    </th>
                                    <th style="text-align: center;">
                                        Reconcile Amount
                                    </th>
                                    <th style="text-align: center;">
                                        Restock Amount
                                    </th>
                                    <th style="text-align: center;">
                                        Total On Hand
                                    </th>
                                    <th style="text-align: center;">
                                        Sales Revenue
                                    </th>
                                </tr>
                            </b-thead>

                            <tbody>
                                <tr
                                    :key="index"
                                    v-for="(category, index) in params.summary"
                                >
                                    <td align="left">
                                        <a
                                            href="#"
                                            v-scroll-to="
                                                category.category
                                                    ? '#' +
                                                      category.category
                                                          .split(/ |\//)
                                                          .join('_')
                                                    : ''
                                            "
                                        >
                                            {{ category.category }}
                                        </a>
                                    </td>
                                    <td align="center">
                                        {{ category.purchases.toFixed(2) }}
                                    </td>
                                    <td align="center">
                                        {{ category.total_sold.toFixed(2) }}
                                    </td>
                                    <td align="center">
                                        {{
                                            category.reconcile_amount.toFixed(2)
                                        }}
                                    </td>
                                    <td align="center">
                                        {{ category.restock_amount.toFixed(2) }}
                                    </td>
                                    <td align="center">
                                        {{ category.total_on_hand.toFixed(2) }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{
                                            category.sales_revenue.toFixed(2)
                                        }}
                                    </td>
                                </tr>
                                <tr class="total">
                                    <td align="left" colspan="6">Total</td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ totalSalesRevenue }}
                                    </td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                        <br />
                    </div>
                </div>
                <div v-else>
                    <b
                        >Please select one or more filters to generate this
                        report.</b
                    >
                </div>
            </div>

            <!-- Detail report for each category -->
            <div id="report-body" v-if="loaded" class="w-100">
                <div v-if="params.summary.length > 0">
                    <div
                        id="report-result"
                        :key="index"
                        v-for="(detail, index) in params.detail"
                    >
                        <b-table-simple
                            bordered
                            :id="index ? index.split(/ |\//).join('_') : ''"
                            style="margin-bottom: 0px;"
                        >
                            <b-thead head-variant="dark">
                                <tr>
                                    <th width="100%" align="left">
                                        <div>{{ index }}</div>
                                    </th>
                                </tr>
                            </b-thead>
                        </b-table-simple>
                        <b-table-simple bordered style="font-size: smaller;">
                            <b-thead head-variant="light">
                                <tr>
                                    <th style="text-align: left; width: 10%;">
                                        Item
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Start Balance
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Purchases
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Total Sold
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Reconcile Amount
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Restock Amount
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Total On Hand
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Max Cost
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Min Cost
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Avg Cost
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Recent Cost
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Price Type
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Pct Of Cost
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Price
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Sales Revenue
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Max COGS
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Min COGS
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Avg COGS
                                    </th>
                                    <th style="text-align: center; width: 5%;">
                                        Recent COGS
                                    </th>
                                </tr>
                            </b-thead>

                            <tbody>
                                <tr
                                    :key="index"
                                    v-for="(item_name, index) in detail"
                                >
                                    <td align="left">
                                        <item-name
                                            v-if="
                                                item_name.item_id &&
                                                item_name.item_status ===
                                                    'Active'
                                            "
                                            :item="{
                                                name: item_name.item_name,
                                                encodedId: item_name.item_id
                                            }"
                                        />
                                        <span v-else>
                                            {{ item_name.item_name }}
                                        </span>
                                    </td>
                                    <td align="center">
                                        {{ item_name.start_balance }}
                                    </td>
                                    <td align="center">
                                        {{ item_name.purchases }}
                                    </td>
                                    <td align="center">
                                        {{ item_name.total_sold }}
                                    </td>
                                    <td align="center">
                                        {{ item_name.reconcile_amount }}
                                    </td>
                                    <td align="center">
                                        {{ item_name.restock_amount }}
                                    </td>
                                    <td align="center">
                                        {{ item_name.total_on_hand }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ item_name.max_cost }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ item_name.min_cost }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ item_name.avg_cost }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ item_name.recent_cost }}
                                    </td>
                                    <td align="center">
                                        {{ item_name.price_type }}
                                    </td>
                                    <td align="center">
                                        {{ item_name.pct_of_cost }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ item_name.price }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ item_name.sales_revenue }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ getMaxCOGS(item_name) }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ getMinCOGS(item_name) }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ getAvgCOGS(item_name) }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ getRecentCOGS(item_name) }}
                                    </td>
                                </tr>
                                <tr class="total bg-light">
                                    <td align="left" colspan="14">Total</td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ getSubTotalSalesRevenue(detail) }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ getSubTotalMaxCOGS(detail) }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ getSubTotalMinCOGS(detail) }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ getSubTotalAvgCOGS(detail) }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ getSubTotalRecentCOGS(detail) }}
                                    </td>
                                </tr>
                                <tr
                                    v-if="index == last_category"
                                    class="total bg-secondary"
                                >
                                    <td align="left" colspan="14">
                                        Grand Total
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ grandTotalSalesRevenue }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ grandTotalMaxCOGS }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ grandTotalMinCOGS }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ grandTotalAvgCOGS }}
                                    </td>
                                    <td align="center">
                                        {{ params.currency
                                        }}{{ grandTotalRecentCOGS }}
                                    </td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                        <br />
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import moment from "moment";
import ItemName from "@/components/commons/item-name";
import Report from "@/mixins/report.js";
export default {
    components: {
        ItemName,
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("day"),
                    end: this.getEndDate("day"),
                    ignoreFormat: 1,
                    datePickerOptions: {
                        format: "MMM YYYY"
                    },
                    category: [],
                    itemClass: 0
                };
            }
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: false,
            meta: "",
            resource: "",
            code: "",
            params: {
                summary: [],
                detail: []
            },
            title: "Inventory Value / Cost of Goods Sold",
            dateRange: ""
        };
    },
    computed: {
        totalSalesRevenue: function () {
            let tot = 0;
            Array.from(this.params.summary).forEach(category => {
                tot += parseFloat(category.sales_revenue);
            });
            return tot.toFixed(2);
        },
        grandTotalSalesRevenue: function () {
            let tot = 0;
            Array.from(this.params.summary).forEach(category => {
                tot += parseFloat(category.sales_revenue);
            });
            return tot.toFixed(2);
        },
        grandTotalMaxCOGS: function () {
            let tot = 0;
            Array.from(this.params.summary).forEach(category => {
                tot += parseFloat(category.max_cogs);
            });
            return tot.toFixed(2);
        },
        grandTotalMinCOGS: function () {
            let tot = 0;
            Array.from(this.params.summary).forEach(category => {
                tot += parseFloat(category.min_cogs);
            });
            return tot.toFixed(2);
        },
        grandTotalAvgCOGS: function () {
            let tot = 0;
            Array.from(this.params.summary).forEach(category => {
                tot += parseFloat(category.avg_cogs);
            });
            return tot.toFixed(2);
        },
        grandTotalRecentCOGS: function () {
            let tot = 0;
            Array.from(this.params.summary).forEach(category => {
                tot += parseFloat(category.recent_cogs);
            });
            return tot.toFixed(2);
        }
    },
    mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.isShowDateRange = true;
        self.data.isShowItemCategory = true;
        self.data.isShowItemClass = true;

        self._getSetting().then(() => {
            self.data.start = self.getStartDate("day");
            self.data.end = self.getEndDate("day");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.data.category = [];
            self.data.itemClass = 0;
            self.data.datePickerOptionDefault = 1;
            self.dynamicPageTitle(self.title);
            self.init();
        });

        self.data.datePickerOptions.format = "MMM YYYY";
        self.$root.$on(
            "report-filter-date-range:refresh",
            self.generateReportQueue
        );
        self.$root.$on("inventory-value-cogs:refresh", function (params) {
            self.generateReportQueue(params);
        });
    },
    beforeDestroy: function () {
        this.data.isShowItemCategory = false;
        this.data.isShowItemClass = false;
        this.$root.$off(
            "report-filter-date-range:refresh",
            this.generateReportQueue
        );
    },
    methods: {
        init(params) {
            let self = this;
            let category = [];
            self.loaded = false;
            self.data.ignoreFormat = 1;

            if (params) {
                self.data.from = params.from;
                self.data.to = params.to;
                self.data.start = params.start;
                self.data.end = params.end;
                self.data.category =
                    params.category.length > 0 ? params.category : [];
                self.data.itemClass = params.itemClass;
            }

            category =
                self.data.category.length > 0
                    ? JSON.stringify(self.data.category)
                    : "";

            return this.$http
                .get(
                    process.env.BARRACUDA +
                        "/report/reports/" +
                        self.$route.params.id,
                    {
                        params: {
                            from: params ? params.from : self.data.from,
                            to: params ? params.to : self.data.to,
                            category: category,
                            item_class: params
                                ? params.itemClass
                                : self.data.itemClass
                        }
                    }
                )
                .then(function (response) {
                    self.loaded = true;
                    if (response.data.response) {
                        self.meta = response.data.response.resource.meta;
                        self.code = response.data.response.message.code;

                        if (self.code === 200) {
                            self.data.start = moment
                                .unix(response.data.response.resource.from)
                                .tz(self._timeZone)
                                .startOf("day");
                            self.data.end = moment
                                .unix(response.data.response.resource.to)
                                .tz(self._timeZone)
                                .endOf("day");

                            self.data.from = self.converToUnix(self.data.start);
                            self.data.to = self.converToUnix(self.data.end);

                            self.data.category = response.data.response.resource
                                .category
                                ? JSON.parse(
                                      response.data.response.resource.category
                                  )
                                : [];

                            self.dateRange = self.getDateRange(
                                response.data.response.resource.from,
                                response.data.response.resource.to
                            );

                            self.params = {
                                currency:
                                    response.data.response.resource.currency,
                                summary:
                                    response.data.response.resource.summary,
                                detail: response.data.response.resource.detail
                            };

                            self.last_category = _.keys(self.params.detail)[
                                Object.keys(self.params.detail).length - 1
                            ];

                            self.data.itemClass =
                                response.data.response.resource.item_class;
                        }
                    } else {
                        self.dialogs["filterDateRangeWindow"].open(self.data);
                    }
                });
        },
        async generateReportQueue(data) {
            let category =
                data.category.length > 0 ? JSON.stringify(data.category) : "";

            let params = {
                from: data ? data.from : data.start.unix(),
                to: data ? data.to : data.end.unix(),
                category: category,
                business_id: this.$root.setting.business_id,
                user_id: this.$root.currentActor.id,
                timezone: this._timeZone,
                item_class: data ? data.itemClass : this.data.itemClass
            };
            let response = await this.$http.post(
                process.env.BARRACUDA +
                    "report/gen-report-queue/" +
                    this.$route.params.id,
                params
            );

            if (response.data.response.mode == 0) {
                this._message(response.data.response.message, "info");
            }
        },
        getMaxCOGS(item) {
            let max = item.total_sold * item.max_cost;
            return max.toFixed(2);
        },
        getMinCOGS(item) {
            let min = item.total_sold * item.min_cost;
            return min.toFixed(2);
        },
        getAvgCOGS(item) {
            let avg = item.total_sold * item.avg_cost;
            return avg.toFixed(2);
        },
        getRecentCOGS(item) {
            let recent = item.total_sold * item.recent_cost;
            return recent.toFixed(2);
        },
        getSubTotalSalesRevenue(data) {
            let tot = 0;
            Object.keys(data).forEach(key => {
                const item = data[key];
                tot += parseFloat(item.sales_revenue);
            });
            return tot.toFixed(2);
        },
        getSubTotalMaxCOGS(data) {
            let tot = 0;
            Object.keys(data).forEach(key => {
                const item = data[key];
                tot += parseFloat(item.total_sold) * parseFloat(item.max_cost);
            });
            return tot.toFixed(2);
        },
        getSubTotalMinCOGS(data) {
            let tot = 0;
            Object.keys(data).forEach(key => {
                const item = data[key];
                tot += parseFloat(item.total_sold) * parseFloat(item.min_cost);
            });
            return tot.toFixed(2);
        },
        getSubTotalAvgCOGS(data) {
            let tot = 0;
            Object.keys(data).forEach(key => {
                const item = data[key];
                tot += parseFloat(item.total_sold) * parseFloat(item.avg_cost);
            });
            return tot.toFixed(2);
        },
        getSubTotalRecentCOGS(data) {
            let tot = 0;
            Object.keys(data).forEach(key => {
                const item = data[key];
                tot +=
                    parseFloat(item.total_sold) * parseFloat(item.recent_cost);
            });
            return tot.toFixed(2);
        }
    }
};
</script>
<style>
.total {
    font-weight: bold;
}
</style>
